import React from 'react';

import AntSegmented, { SegmentedProps } from 'antd/es/segmented';

import { Wrapper } from './styled';

type SegmentedType = Omit<SegmentedProps, 'ref'>;

interface ISegmented extends SegmentedType {
  className?: string;
}

const Segmented = ({ className, ...rest }: ISegmented) => {
  return (
    <Wrapper className={className}>
      <AntSegmented {...rest} />
    </Wrapper>
  );
};

export default Segmented;
